import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { OauthAEMConfig, UserDataService } from '@com-delta-idp/mnx-oauth';
import { share } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { HTTP_TIMEOUT } from '../../interceptor/timeout.interceptor';
import { MostUpcomingTrip } from '../../model/enums/most-upcoming-trips.interface';
import {
  CarTripModel,
  FlightTripModel,
  TripOptions,
  UpcomingTrips,
  VacationTripModel
} from '../../model/upcoming-trip.model';
import { MostUpcomingTripsService } from '../most-upcoming-trips/most-upcoming-trips.service';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class UpcomingTripService {
  upComingTrips: UpcomingTrips;
  upcomingTripDataChanged = new EventEmitter<any>();
  private nmbrOfTrips = '1';

  constructor(
    private _http: HttpClient,
    private config: ApplicationConfig,
    private datalayer: DataLayer,
    private userDataService: UserDataService,
    private mostUpcomingTripsService: MostUpcomingTripsService
  ) {}

  getTripDetails(skymileno) {
    const tripoptions = new TripOptions(skymileno, this.nmbrOfTrips);
    if (this.upComingTrips) {
      return this.upComingTrips;
    } else {
      this.userDataService
        .getAuthConfigContent()
        .subscribe((authConfigResponse: OauthAEMConfig) => {
          if (authConfigResponse.TRIPS_API_AWS) {
            this.mostUpcomingTripsService
              .callMostUpcomingTrips(
                {
                  skyMileNumber: tripoptions.skymilesNbr,
                  numberOfTrips: tripoptions.nmbrOfTrips
                },
                authConfigResponse
              )
              .subscribe(
                (response: MostUpcomingTrip) => {
                  this.processMostUpcomingTripData(response);
                },
                (err) => {
                  this.upcomingTripDataChanged.emit({ data: null, error: err });
                }
              );
          } else {
            this.getTripDetailsFromAPI(tripoptions).subscribe(
              (data) => {
                this.processMostUpcomingTripData(data);
              },
              (err) => {
                this.upcomingTripDataChanged.emit({ data: null, error: err });
              }
            );
          }
        });
    }
  }

  processMostUpcomingTripData(data): void {
    if (data) {
      this.upComingTrips = new UpcomingTrips();
      let conditionArr = [
        {
          condition: () => data['totalTrips'],
          action: () => (this.upComingTrips.totaltrips = data['totalTrips'])
        },
        {
          condition: () => data['transactionId'],
          action: () =>
            (this.upComingTrips.transactionId = data['transactionId'])
        },
        {
          condition: () => data['viewAllTripsLink'],
          action: () =>
            (this.upComingTrips.viewAlltrips = data['viewAllTripsLink'])
        },
        {
          condition: () => data['carTrip'],
          action: () => {
            const carTrip = data['carTrip'];
            this.upComingTrips.carTripDetails = new CarTripModel(
              carTrip.detailsLink,
              carTrip.dateRange,
              carTrip.pickupCity,
              carTrip.vendorConfirmationNbr,
              carTrip.vendorName
            );
            if (this.upComingTrips.carTripDetails.vendorName) {
              this.upComingTrips.carTripDetails.vendorName =
                this.upComingTrips.carTripDetails.vendorName.toLowerCase();
            }
            this.upComingTrips.hasUpComingTrip = true;
          }
        },
        {
          condition: () => data['trip'],
          action: () => {
            this.upComingTrips.hasUpComingTrip = true;
            const flightTrip = data['trip'];
            this.upComingTrips.flightTripDetails = new FlightTripModel(
              flightTrip.checkedIn,
              flightTrip.checkinEligible,
              flightTrip.checkinLink,
              flightTrip.dateRange,
              flightTrip.destinationCity,
              flightTrip.detailsLink,
              flightTrip.iropClean,
              flightTrip.iropImpact,
              flightTrip.iropMessage,
              flightTrip.pnrNbr
            );
          }
        },
        {
          condition: () => data['vacationTrip'],
          action: () => {
            this.upComingTrips.hasUpComingTrip = true;
            const vacationTrip = data['vacationTrip'];
            this.upComingTrips.vacationTripDetails = new VacationTripModel(
              vacationTrip.checkedIn,
              vacationTrip.checkinEligible,
              vacationTrip.checkinLink,
              vacationTrip.dateRange,
              vacationTrip.destinationCityName,
              vacationTrip.detailsLink,
              vacationTrip.iropClean,
              vacationTrip.iropImpact,
              vacationTrip.iropMessage,
              vacationTrip.vacationConfirmationNbr
            );
          }
        }
      ];

      conditionArr.filter((obj) => {
        if (obj.condition()) {
          obj.action();
        }
      });

      this.upcomingTripDataChanged.emit({
        data: this.upComingTrips,
        error: null
      });
      this.datalayer.upcomingTripData = this.upComingTrips.flightTripDetails;
      this.datalayer.compile();
      this.datalayer.init();
    }
  }

  getTripDetailsFromAPI(tripoptions) {
    const svcTimeOut: number = Number.parseInt(
      this.config.get('APP_TIMEOUT_SLOW')
    );
    const retries: number = Number.parseInt(this.config.get('APP_RETRIES'));

    const requestOptions = {
      headers: new HttpHeaders(),
      params: new HttpParams()
    };
    requestOptions.headers.set(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    requestOptions.headers.append('Accept', 'application/json');
    requestOptions.headers.append(HTTP_TIMEOUT, svcTimeOut.toString());
    return this._http
      .post(
        `${this.config.get('APP_TRIPS_UPCOMING_TRIP_URL')}?skymilesNbr=${
          tripoptions.skymilesNbr
        }&nmbrOfTrips=${tripoptions.nmbrOfTrips}`,
        null,
        requestOptions
      )
      .pipe(share());
  }
}
